<template>
  <section class="result-section mt-3">
    <b-container class="text-left">
      <h1>{{ title }}</h1>

      <b-row
        v-if="userCompanyOptions !== null && userCompanyOptions !== undefined && userCompanyOptions.length !== 0"
        class="mt-5 mb-5"
      >
        <b-col cols="12" lg="6" class="mb-5 mb-lg-0">
          <b-row>
            <b-col cols="12" class="mb-5">
              <select-company currentPage="kkv-result" :disableSelector="!loaded" @onSelectionChange="refreshResults" />
            </b-col>

            <b-col cols="12">
              <h3>{{ description }}</h3>

              <div class="d-flex mb-3 mt-5">
                <CheckedSvg class="mr-4" />
                <h3>{{ list1 }}</h3>
              </div>

              <div class="d-flex">
                <CheckedSvg class="mr-4" />
                <h3>{{ list2 }}</h3>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" lg="5" offset-lg="1">
          <b-img class="mw-100" src="../../assets/img/result/hero.svg" />
        </b-col>
      </b-row>
    </b-container>

    <div v-if="!error" class="economic-indicators text-left">
      <b-container>
        <h2 class="text-white pb-4">{{ economicTitle }}</h2>

        <b-row>
          <b-col cols="12" lg="5">
            <p class="mb-0" v-html="economicDescription"></p>
          </b-col>

          <b-col cols="12" lg="6" offset-lg="1">
            <div class="company-details">
              <h3 class="mb-3 font-weight-bold text-gray-04">
                {{ selectedUserCompanyShortName }}
              </h3>
              <p class="mb-1 text-gray-04">{{ selectedUserCompanyLongName }}</p>
              <p class="mb-3 text-gray-04">{{ selectedUserCompanyAddress }}</p>

              <b-row>
                <b-col cols="6">
                  <p class="mb-2 text-gray-04 font-weight-bold">Cégjegyzékszám:</p>
                </b-col>
                <b-col cols="6">
                  <p class="mb-2 text-gray-04">{{ selectedUserCompanyRegnb }}</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="6">
                  <p class="text-gray-04 font-weight-bold mb-0">Adószám:</p>
                </b-col>
                <b-col cols="6">
                  <p class="text-gray-04 mb-0">{{ selectedUserCompanyTaxnb }}</p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div v-if="!error" class="text-left bg-color-gray-01 py-5">
      <b-container class="pt-0 pt-lg-5">
        <h2 class="mb-4 mb-lg-5 font-weight-bold">Keresett vállalkozás pénzügyi adatai</h2>

        <Decision
          class="mb-4"
          :Title="'Foglalkoztatotti létszám:'"
          :Value="`${actualCompany.HeadCountValue} fő`"
          :isLoaded="loaded"
        />
        <Decision
          class="mb-4 mt-5 mt-lg-0"
          :Title="'Éves nettó árbevétel:'"
          :Value="`${actualCompany.IncomeValue} HUF`"
          :isLoaded="loaded"
        />
        <Decision
          class="mb-4 mt-5 mt-lg-0"
          :Title="'Mérlegfőösszeg:'"
          :Value="`${actualCompany.BalanceSheetTotalValue} HUF`"
          :isLoaded="loaded"
        />
      </b-container>
    </div>

    <div v-if="!error" class="text-left bg-color-gray-01 py-5 mt-5">
      <b-container class="pt-0 pt-lg-5">
        <h2 class="mb-4 mb-lg-5 font-weight-bold">
          Teljes cég-hálózat pénzügyi adatai
        </h2>

        <Decision
          class="mb-4"
          :Title="'Foglalkoztatotti létszám:'"
          :Value="`${networkCert.HeadCountValue} fő`"
          :isLoaded="loaded"
        />
        <Decision
          class="mb-4 mt-5 mt-lg-0"
          :Title="'Éves nettó árbevétel:'"
          :Value="`${networkCert.IncomeValue} EUR`"
          :isLoaded="loaded"
        />
        <Decision
          class="mb-4 mt-5 mt-lg-0"
          :Title="'Mérlegfőösszeg:'"
          :Value="`${networkCert.BalanceSheetTotalValue} EUR`"
          :isLoaded="loaded"
        />
      </b-container>
    </div>

    <div v-if="!error" class="text-left mt-5">
      <b-container>
        <b-row class="know-section">
          <b-col cols="12" lg="6">
            <b-row class="bg-color-green">
              <b-col class="bg-color-white rounded-right-bottom">
                <h2 class="mb-3 pl-4 text-green font-weight-bold">Tudta?</h2>
              </b-col>
            </b-row>

            <b-row class="bg-color-green not-rounded-right-top pt-4">
              <b-col cols="12" lg="10" class="p-4 know-description">
                <p class="text-white mb-0 pb-3">
                  {{ knowDescription }}
                </p>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" lg="5" offset-lg="1" class="justify-content-center">
            <b-img class="mw-100 mt-4" src="../../assets/img/result/smeClassification.svg" />
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col cols="12" lg="7">
            <h2>Minősítés eredménye</h2>
            <p class="mt-4 mb-0" v-html="ratingDescription"></p>
          </b-col>
        </b-row>

        <b-row class="my-5 align-items-center">
          <b-col cols="12" lg="10">
            <div class="company-details">
              <h3 class="mb-3 font-weight-bold text-gray-04">KKV minősítés</h3>

              <b-row>
                <b-col cols="6">
                  <h3 class="mb-2 text-gray-04 font-weight-bold">KKV státusz:</h3>
                </b-col>
                <b-col cols="6">
                  <h3 class="mb-2 font-weight-bold" :class="kkvStatusClass">{{ kkvStatus }}</h3>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container v-if="error" class="text-left mb-4 mb-lg-5 pt-lg-4">
      <b-row class="align-items-start mt-5">
        <b-col cols="12" lg="6">
          <h2 class="text-red">{{ missingReportTitle }}</h2>
          <h3 class="mt-md-5">
            A KKV minősítés lekérdezése közben hiba lépett fel.
          </h3>
        </b-col>

        <b-col cols="12" lg="6" class="d-flex justify-content-end mt-5 mt-lg-0">
          <b-img class="mw-100 missing-report-image" src="../../assets/img/result/undraw_identation.svg" />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import SelectCompany from '@/components/SelectCompany.vue'
import CheckedSvg from '@/components/svg/Result/Checked.vue'
import { mapGetters } from 'vuex'
import Decision from './Decision'

export default {
  name: 'Result',

  components: {
    CheckedSvg,
    Decision,
    SelectCompany
  },

  data() {
    return {
      title: 'Az Ön vállalkozásának besorolása',
      description:
        'Az indikatív online cégbesorolás eredménye alapján célzottabban tud keresni a fejlesztési lehetőségek között, válogatni az aktuálisan elérhető támogatások kínálatából.',
      list1: 'A meghatározott pénzügyi adatok megjelenítése',
      list2: 'A teljes cég-hálózat összesített mutatóinak figyelembevétele',
      economicTitle: 'Gazdasági mutatók',
      economicDescription:
        'Az adatszolgáltatása alapján a saját vállalkozás és a teljes cég-hálózat fő gazdasági mutatói jelennek meg. A saját vállalkozás adatai HUF-ban, a teljes cég-hálózat összesített adatai EUR-ban kerülnek megjelenítésre.',
      knowDescription:
        'A cég minősítésekor nemcsak a saját vállalkozás gazdasági mutatóit, hanem a teljes cég-hálózat összesített mutatóit is figyelembe kell venni.',
      ratingDescription:
        'A megjelenített minősítés a szolgáltatott adatok alapján kerül megjelenítésre. A megadott információ előzetes tájékoztatásként szolgál az elérhető támogatások és pénzügyi eszközök között való célzott kereséshez.',
      missingReportTitle: 'Sikertelen lekérdezés',
      loaded: false,
      dnbResult: null,
      error: false,
      rawDnb: ''
    }
  },

  computed: {
    ...mapGetters(['selectedUserCompany', 'userCompanies', 'selectedCompany', 'userCompanyOptions']),

    selectedUserCompanyShortName() {
      return this.selectedUserCompany?.companyData?.short_name?.[0]?.name ?? ''
    },

    selectedUserCompanyLongName() {
      return this.selectedUserCompany?.companyData?.long_name?.[0]?.name ?? ''
    },

    selectedUserCompanyAddress() {
      return this.selectedUserCompany?.companyData?.address?.[0]?.address ?? ''
    },

    selectedUserCompanyRegnb() {
      return this.selectedUserCompany?.companyData?.company_registration_number?.[0]?.company_registration_number ?? ''
    },

    selectedUserCompanyTaxnb() {
      return this.selectedUserCompany?.companyData?.tax_number?.[0]?.tax_number ?? ''
    },
    kkvStatusClass() {
      const status = String(this.kkvStatus || '').toLowerCase()

      if (status.includes('nagyvállalat') || status.includes('nagyvallalat')) {
        return 'status-red'
      }

      if (
        status.includes('kkv') ||
        status.includes('mikro') ||
        status.includes('kisvállalkozás') ||
        status.includes('középvállalkozás')
      ) {
        return 'status-green'
      }

      return 'text-gray-04'
    },

    actualCompany() {
      return {
        HeadCountValue: this.numberWithSpaces(this.dnbResult?.company?.staff),
        IncomeValue: this.numberWithSpaces(this.dnbResult?.company?.netSalesHuf),
        BalanceSheetTotalValue: this.numberWithSpaces(this.dnbResult?.company?.balanceHuf)
      }
    },

    networkCert() {
      return {
        HeadCountValue: this.numberWithSpaces(this.dnbResult?.group?.staff),
        IncomeValue: this.numberWithSpaces(this.dnbResult?.group?.netSalesEur),
        BalanceSheetTotalValue: this.numberWithSpaces(this.dnbResult?.group?.balanceEur)
      }
    },

    rating() {
      return this.dnbResult?.rating ?? ''
    },

    kkvStatus() {
      return this.dnbResult?.kkvStatus ?? ''
    }
  },

  async mounted() {
    const companyId = this.$route.query.companyId

    this.$gtag.event('kkv_qualifier', {
      event_category: 'user_interaction',
      companyId: companyId
    })

    await this.$store.dispatch('getUserCompanies', {})

    if (!this.userCompanies || this.userCompanies.length === 0) {
      this.error = true
      this.loaded = true
      return
    }

    if (!this.selectedUserCompany && !companyId) {
      this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
    }

    if (companyId) {
      const userAssignedCompany = this.userCompanies.find(userCompany => {
        return userCompany.companyId == companyId
      })

      if (userAssignedCompany) {
        const getCompanyQueryParams = {
          value: userAssignedCompany.companyId
        }

        await this.$store.dispatch('getCompany', getCompanyQueryParams)
        this.$store.commit('setSelectedUserCompany', userAssignedCompany)
      } else {
        this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
      }
    }

    await this.refreshResults(companyId)
  },

  methods: {
    async refreshResults(payload) {
      let effectiveCompanyId = ''

      if (typeof payload === 'object' && payload !== null) {
        effectiveCompanyId = payload.companyId || payload.value || ''
      } else {
        effectiveCompanyId = payload || this.selectedUserCompany?.companyId || ''
      }

      if (!effectiveCompanyId) {
        this.error = true
        this.loaded = true
        return
      }

      if (this.$route.query.companyId !== String(effectiveCompanyId)) {
        this.$router.push({
          path: '/kkv-result',
          query: { companyId: effectiveCompanyId }
        })
      }

      this.loaded = false
      this.error = false
      this.dnbResult = null
      this.rawDnb = ''

      try {
        const result = await this.$store.dispatch('getKkvResult', effectiveCompanyId)

        if (!result) {
          throw new Error('Üres válasz érkezett a getKkvResult actionből.')
        }

        this.dnbResult = result
        this.rawDnb = JSON.stringify(result?.raw ?? {}, null, 2)
      } catch (error) {
        this.error = true
      } finally {
        this.loaded = true
      }
    },

    numberWithSpaces(value) {
      if (value === null || value === undefined || value === '') {
        return '0'
      }

      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }
}
</script>

<style scoped>
.know-description {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.status-green {
  color: #00903c;
}

.status-red {
  color: #d0021b;
}

.btn-secondary:hover {
  background-color: var(--color-gray-03);
  border-color: var(--color-gray-03);
  color: var(--white) !important;
}

.company-details {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 40px;
  padding-left: 100px;
  padding-right: 100px;
}

.economic-indicators {
  padding-top: 5rem;
  padding-bottom: 5rem;
  background-color: #00903c;
  color: #ffffff !important;
}

.not-rounded-right-top {
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-bottom-left-radius: 50px;
}

.rounded-right-bottom {
  border-bottom-right-radius: 50px;
}

.missing-report-image {
  max-width: 350px;
}

@media (max-width: 991px) {
  .classification {
    margin-bottom: 40px;
  }
}

@media (max-width: 993px) {
  h1 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
  }

  h2 {
    font-size: 18px;
    line-height: 24px;
  }

  h3 {
    font-size: 16px;
    line-height: 24px;
  }

  p {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
  }

  .economic-indicators {
    padding-top: 2rem;
    padding-bottom: 3rem;
  }

  .company-details {
    margin-top: 30px;
    padding: 20px;
  }

  .know-section {
    padding: 15px;
  }
}
</style>
